export default "__VITE_ASSET__pPPpzevB__"